import { render, staticRenderFns } from "./TabSonsPadrillos.vue?vue&type=template&id=2f337b24&scoped=true"
import script from "./TabSonsPadrillos.vue?vue&type=script&lang=js"
export * from "./TabSonsPadrillos.vue?vue&type=script&lang=js"
import style0 from "./TabSonsPadrillos.vue?vue&type=style&index=0&id=2f337b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f337b24",
  null
  
)

export default component.exports